export default __webpack_public_path__ + "static/cruiselines-carnival-ship-4-edd23e1fd91c22ce17eaa113864de835.jpg";